import React from 'react';
import PropTypes from 'prop-types';
import { LinkButton } from '@adsk/alloy-react-button';
import { useLocale } from '@adsk/alloy-react-locale';
import theme from '@adsk/alloy-react-theme';
const TableConfigurationReset = _ref => {
  let {
    label,
    reset
  } = _ref;
  const {
    T
  } = useLocale(_ref2 => {
    let {
      locale
    } = _ref2;
    return require("../../i18n/".concat(locale, ".json"));
  });
  const resetLabel = T.translate('RESET_ALL');
  return /*#__PURE__*/React.createElement(LinkButton, {
    "data-testid": 'TableConfigurationMenu__ResetAll',
    size: LinkButton.SIZES.SMALL,
    style: {
      margin: "18px ".concat(theme.spacing.L, "px")
    },
    onClick: reset
  }, label || resetLabel);
};
TableConfigurationReset.propTypes = {
  label: PropTypes.any,
  reset: PropTypes.func.isRequired
};
export default TableConfigurationReset;
//# sourceMappingURL=Reset.js.map